import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
	Flex,
	HStack,
	Icon,
	Link,
	List,
	Text,
	useDisclosure,
} from '@chakra-ui/react';
import { CrmMemberAssociationModal } from 'components/modal/CrmMemberAssociationModal';
import { TooltipStandard } from 'components/tooltip/TooltipStandard';
import { useGlobalContext } from 'contexts/GlobalContext';
import { FaCircle } from 'react-icons/fa';
import { NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { globalStyles } from 'theme/styles';
import { getLocalStorageCrm } from 'utils/functions/localStorageCrmManager';

import { HSeparator } from '../../separator/Separator';

const activeColor = globalStyles.colors.easyBLUE[300];
const inactiveColor = globalStyles.colors.easyBLUE[200];
const accordionBtColor = globalStyles.colors.easyBLUE[150];
const activeIcon = globalStyles.colors.easyRED[300];
const inactiveIcon = globalStyles.colors.easyBLUE[300];

const Item = styled.div`
	.textHeader {
		color: ${props =>
			props.activeRoute(props.route.path) ? activeColor : inactiveColor};
	}
	.icon {
		color: ${props =>
			props.activeRoute(props.route.path) ? activeIcon : inactiveIcon};
	}
	:hover {
		.textHeader {
			color: ${activeColor};
		}
		.icon {
			color: ${activeIcon};
		}
	}
	width: 100%;
`;

const ItemModule = styled.div`
	.textHeader {
		color: ${props =>
			props.activeRoute(props.route.path) ? activeColor : inactiveColor};
	}
	.icon {
		color: ${props =>
			props.activeRoute(props.route.path)
				? activeIcon
				: !props.route.permissions
				? inactiveColor
				: inactiveIcon};
	}
	:hover {
		.textHeader {
			color: ${props =>
				props.route.permissions ? activeColor : inactiveColor};
		}
		.icon {
			color: ${props =>
				props.route.permissions ? activeIcon : inactiveColor};
		}
	}
	width: 100%;
`;

export function SidebarLinks(props) {
	const { sidebarState } = props;
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { userInfos } = useGlobalContext();
	const hasAdminNotAssociatedMemberCrmModalMessage = getLocalStorageCrm();

	const location = useLocation();

	const { routes } = props;

	const activeRoute = routeName => {
		return location.pathname.includes(routeName);
	};

	const createLinks = routes => {
		return routes.map((route, key) => {
			if (route.collapse && !route.iconLock && !route.permissions) {
				return (
					<Accordion
						allowToggle
						key={key}
					>
						<Item
							route={route}
							activeRoute={activeRoute}
						>
							<AccordionItem
								border='none'
								key={key}
							>
								<AccordionButton
									_hover={{
										background: 'transparent',
									}}
									display={
										route.notShowItemMenu ? 'none' : 'flex'
									}
									align='center'
									justify='center'
									_focus={{
										background: 'none',
									}}
									borderRadius='8px'
									w={{
										sm: '100%',
										xl: '100%',
										'2xl': '95%',
									}}
									px={route.icon ? null : '0px'}
									py='0px'
									bg={'transparent'}
									ms={0}
								>
									{route.icon ? (
										<Flex
											width='100%'
											alignItems={'center'}
											justifyContent='space-between'
										>
											<HStack
												mb='15px'
												spacing={
													activeRoute(route.path)
														? '22px'
														: '26px'
												}
											>
												<Flex
													w='100%'
													alignItems='center'
													justifyContent='center'
												>
													<Box
														me='8px'
														mt='3px'
														className='icon'
													>
														{sidebarState ===
														'closed' ? (
															<TooltipStandard
																label={
																	route.name
																}
																placement='right'
																hasArrow
																bg='easyBLUE.100'
																color='easyBLUE.300'
																fontSize='sm'
																openDelay={500}
															>
																<Box
																	color={
																		activeRoute(
																			route.path
																		)
																			? activeIcon
																			: inactiveIcon
																	}
																	_hover={{
																		color: activeIcon,
																		transform:
																			'scale(1.1)',
																		transition:
																			'all 0.2s ease-in-out',
																		cursor: 'pointer',
																	}}
																>
																	{route.icon}
																</Box>
															</TooltipStandard>
														) : (
															<Box>
																{route.icon}
															</Box>
														)}
													</Box>
													<Text
														me='auto'
														className='textHeader'
														fontWeight='500'
														fontSize='sm'
														display={
															sidebarState ===
															'opened'
																? 'flex'
																: 'none'
														}
													>
														{route.name}
													</Text>
												</Flex>
											</HStack>
											<AccordionIcon
												ms='auto'
												mb='16px'
												color={accordionBtColor}
												transform={
													route.icon
														? null
														: 'translateX(-70%)'
												}
												display={
													sidebarState === 'opened'
														? 'flex'
														: 'none'
												}
											/>
										</Flex>
									) : (
										<Flex
											pt='0px'
											pb='10px'
											alignItems='center'
											w='100%'
										>
											<HStack
												spacing={
													activeRoute(route.path)
														? '22px'
														: '26px'
												}
												ps='34px'
											>
												<Text
													me='auto'
													color={
														activeRoute(route.path)
															? activeColor
															: inactiveColor
													}
													fontWeight='500'
													fontSize='sm'
													_hover={{
														color: activeColor,
													}}
												>
													{route.name}
												</Text>
											</HStack>
											<AccordionIcon
												ms='auto'
												color={'easyBLUE.200'}
												transform={null}
											/>
										</Flex>
									)}
								</AccordionButton>
								<AccordionPanel
									pe={route.icon ? null : '0px'}
									py='0px'
									ps={route.icon ? null : '8px'}
								>
									<List>
										{sidebarState === 'opened'
											? route.icon
												? createLinks(route.items)
												: createAccordionLinks(
														route.items
												  )
											: null}
									</List>
								</AccordionPanel>
							</AccordionItem>
						</Item>
						{route.notShowItemMenu === undefined ? (
							<HSeparator
								mb='20px'
								bg='secondaryGray.400'
							/>
						) : null}
					</Accordion>
				);
			} else {
				const hasPermissions = route.permissions;
				const hasAdminNotAssociatedMessage =
					hasAdminNotAssociatedMemberCrmModalMessage;
				const hasMembroId = userInfos?.membro_id;
				const isDisabled = route.disabled;

				const handleOnClickModal = () => {
					if (
						hasPermissions &&
						!hasMembroId &&
						!hasAdminNotAssociatedMessage &&
						!isDisabled
					) {
						onOpen();
					}
				};

				const handleLinkHref = () => {
					if (
						hasPermissions &&
						(hasMembroId || hasAdminNotAssociatedMessage) &&
						!isDisabled
					) {
						return route.link;
					}
					return null;
				};

				return (
					<>
						{route.collapse ? (
							<Link
								key={key}
								href={handleLinkHref()}
								isExternal
								onClick={handleOnClickModal}
							>
								<ItemModule
									route={route}
									activeRoute={activeRoute}
								>
									<Flex
										display={
											route.notShowItemMenu
												? 'none'
												: 'flex'
										}
										align='center'
										justifyContent='space-between'
										w='100%'
										ps='17px'
										mb='0px'
										_hover={{
											cursor:
												!route.permissions &&
												'not-allowed',
										}}
									>
										<HStack
											mb='6px'
											spacing={
												activeRoute(route.path)
													? '22px'
													: '26px'
											}
										>
											<Flex
												w='100%'
												alignItems='center'
												justifyContent='center'
											>
												<Box
													me='8px'
													mt='3px'
													className='icon'
												>
													{sidebarState ===
													'closed' ? (
														<TooltipStandard
															label={route.name}
															placement='right'
															hasArrow
															bg='easyBLUE.100'
															color='easyBLUE.300'
															fontSize='sm'
															openDelay={100}
														>
															<Box
																color={
																	activeRoute(
																		route.path
																	)
																		? activeIcon
																		: inactiveIcon
																}
																_hover={{
																	color: activeIcon,
																	transform:
																		'scale(1.1)',
																	transition:
																		'all 0.2s ease-in-out',
																	cursor: 'pointer',
																}}
															>
																{route.permissions
																	? route.icon
																	: route.iconLock}
															</Box>
														</TooltipStandard>
													) : (
														<Box>
															{route.permissions
																? route.icon
																: route.iconLock}
														</Box>
													)}
												</Box>
												<Text
													me='auto'
													className={'textHeader'}
													fontWeight='500'
													fontSize='sm'
													display={
														sidebarState ===
														'opened'
															? 'flex'
															: 'none'
													}
												>
													{route.name}
												</Text>
											</Flex>
										</HStack>
									</Flex>
								</ItemModule>
								{userInfos && !userInfos?.membro_id && (
									<CrmMemberAssociationModal
										isOpen={isOpen}
										onClose={onClose}
									/>
								)}
							</Link>
						) : (
							<>
								{isDisabled ? (
									<TooltipStandard
										label={route.disabledTooltip || ''}
										placement='right'
										hasArrow
										bg='gray.200'
										color='blue.800'
										fontSize='sm'
									>
										<Box
											display={
												route.notShowItemMenu
													? 'none'
													: 'flex'
											}
											ms={null}
											opacity={0.5}
											cursor='not-allowed'
										>
											<Flex
												ps='34px'
												alignItems='center'
												mb='8px'
											>
												<Text
													color='gray.400'
													fontWeight='500'
													fontSize='sm'
												>
													{route.name}
												</Text>
											</Flex>
										</Box>
									</TooltipStandard>
								) : (
									<NavLink
										to={
											route.iconLock === undefined &&
											route.layout + route.path
										}
										key={key}
									>
										<Box
											display={
												route.notShowItemMenu
													? 'none'
													: 'flex'
											}
											ms={null}
										>
											<Flex
												ps='34px'
												alignItems='center'
												mb='8px'
											>
												<Text
													_hover={{
														color: activeColor,
													}}
													color={
														activeRoute(route.path)
															? activeIcon
															: inactiveColor
													}
													fontWeight='500'
													fontSize='sm'
												>
													{route.name}
												</Text>
											</Flex>
										</Box>
									</NavLink>
								)}
							</>
						)}
						{route.iconLock && (
							<HSeparator
								mb='20px'
								bg='secondaryGray.400'
							/>
						)}
					</>
				);
			}
		});
	};

	const createAccordionLinks = routes => {
		return routes.map((route, key) => {
			const isDisabled = route.disabled;

			return isDisabled ? (
				<TooltipStandard
					key={key}
					label={route.disabledTooltip || ''}
					placement='right'
					hasArrow
					bg='gray.200'
					color='blue.800'
					fontSize='sm'
				>
					<Box
						ms='28px'
						display={route.notShowItemMenu ? 'none' : 'flex'}
						alignItems='center'
						mb='10px'
						opacity={0.5}
						cursor='not-allowed'
					>
						<Icon
							w='6px'
							h='6px'
							me='8px'
							as={FaCircle}
							color='gray.400'
						/>
						<Text
							color='gray.400'
							fontWeight='normal'
							fontSize='sm'
						>
							{route.name}
						</Text>
					</Box>
				</TooltipStandard>
			) : (
				<NavLink
					to={route.layout + route.path}
					key={key}
				>
					<Box
						ms='28px'
						display={route.notShowItemMenu ? 'none' : 'flex'}
						alignItems='center'
						mb='10px'
						key={key}
					>
						<Icon
							w='6px'
							h='6px'
							me='8px'
							as={FaCircle}
							color={activeIcon}
						/>
						<Text
							color={
								activeRoute(route.path)
									? activeColor
									: inactiveColor
							}
							fontWeight={
								activeRoute(route.path) ? 'bold' : 'normal'
							}
							fontSize='sm'
							_hover={{
								color: activeColor,
							}}
						>
							{route.name}
						</Text>
					</Box>
				</NavLink>
			);
		});
	};

	return createLinks(routes);
}

export default SidebarLinks;
